import React, { useState } from 'react';
import FAQItem from '../components/FAQItem';
const ContactPage = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        company: '',
        subject: '',
        message: ''
    });

    const handleSubmit = (e) => {
        e.preventDefault();
        alert('Thank you for your message! We will get back to you soon.');
        setFormData({ name: '', email: '', company: '', subject: '', message: '' });
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const faqData = [
        {
            question: "What industries do you serve?",
            answer: "We serve a wide range of industries including manufacturing, healthcare, finance, retail, and logistics. Our AI solutions are designed to be adaptable to various business models and operational requirements."
        },
        {
            question: "How long does implementation take?",
            answer: "Implementation timelines vary based on project complexity, typically ranging from 3-12 months. We work closely with your team to ensure minimal disruption to ongoing operations while delivering maximum value."
        },
        {
            question: "Do you provide ongoing support?",
            answer: "Yes, we provide comprehensive ongoing support including monitoring, maintenance, updates, and optimization. Our team ensures your AI solutions continue to evolve with your business needs."
        }
    ];

    return (
        <div className="contact-page">
            {/* Contact Hero */}
            <section className="contact-hero">
                <div className="container">
                    <h1>Get In Touch</h1>
                    <p>Ready to transform your business with AI? Let's start the conversation.</p>
                </div>
            </section>

            {/* Contact Form */}
            <section className="contact-content">
                <div className="container">
                    <div className="contact-grid">
                        <div className="contact-form">
                            <h3>Send us a Message</h3>
                            <form onSubmit={handleSubmit}>
                                <div className="form-group">
                                    <label htmlFor="name">Name *</label>
                                    <input
                                        type="text"
                                        id="name"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="email">Email *</label>
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="company">Company</label>
                                    <input
                                        type="text"
                                        id="company"
                                        name="company"
                                        value={formData.company}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="subject">Subject</label>
                                    <input
                                        type="text"
                                        id="subject"
                                        name="subject"
                                        value={formData.subject}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="message">Message *</label>
                                    <textarea
                                        id="message"
                                        name="message"
                                        rows="5"
                                        value={formData.message}
                                        onChange={handleChange}
                                        required
                                    ></textarea>
                                </div>
                                <button type="submit" className="cta-button">Send Message</button>
                            </form>
                        </div>
                        <div className="contact-info">
                            <h3>Contact Information</h3>
                            <div className="contact-item">
                                <div className="contact-item-icon">📍</div>
                                <div>
                                    <h4>Address</h4>
                                    <p>56 Lantern Circle<br />Stamford</p>
                                </div>
                            </div>
                            <div className="contact-item">
                                <div className="contact-item-icon">📧</div>
                                <div>
                                    <h4>Email</h4>
                                    <p>entuberize@gmail.com</p>
                                </div>
                            </div>
                            <div className="contact-item">
                                <div className="contact-item-icon">📱</div>
                                <div>
                                    <h4>Phone</h4>
                                    <p>2033260222</p>
                                </div>
                            </div>
                            <div className="contact-item">
                                <div className="contact-item-icon">🌐</div>
                                <div>
                                    <h4>Social Media</h4>
                                    <p>Follow us for updates</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            {/* FAQ Section */}
            <section className="services" style={{background: 'white'}}>
                <div className="container">
                    <div className="section-header">
                        <h2 className="section-title">Frequently Asked Questions</h2>
                        <p className="section-subtitle">
                            Common questions about our AI solutions and services
                        </p>
                    </div>
                    <div className="faq-container">
                        {faqData.map((faq, index) => (
                            <FAQItem key={index} question={faq.question} answer={faq.answer} />
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ContactPage;